import { LicenseType } from 'features/licenses/types'

// TODO use SWC version instead import { Home } from '@racepointenergy/swc/scs/types'
export interface Home {
  adminCount: number
  admins: [] | null
  cellUrl: string
  channel: number
  city: string
  configAccessExpires: number
  country: string
  created: number
  domainId: string
  grandfathered: boolean
  hostInfo?: HostInfo
  hostType: string
  id: string
  imageUrl: string | null
  lastBackup: number | null
  lastConfig: number | null
  lastContact: number
  latitude: number
  licenses: LicenseType[]
  longitude: number
  monitorAccessEnabled: boolean
  name: string
  notificationsEnabled: boolean
  online: boolean
  otaReady: boolean
  postalCode: string
  remoteAccessEnabled: boolean
  softwareInfo: SoftwareInfo
  state: string
  subscriptions: []
  timezone: string
  uid: string
  userCount: number
  subscriptionInfo: SubscriptionInfo[] | null
}

export interface Price {
  id: string
  amount: number
  name?: string
}

export interface PriceV2 {
  id: string
  unit_amount: number
  name?: string
  nickname: string
  product: {
    name: string
  }
}

interface SoftwareInfo {
  created: number
  endTime: null
  id: number
  startTime: null
  version: Version
}

interface Version {
  build: number
  maintenance: number
  major: number
  minor: number
  name: string
  number: number
}

interface Location {
  expires: number
  url: string
}

export interface HomeActiveConfig {
  components?: { deviceID: string; name: string }[]
  connections?: {
    sourceDeviceID: string
    sourceConnector: { connectorName: string }
    sinkDeviceID: string
    sinkConnector: { connectorName: string }
  }[]
  active: boolean
  created: number
  homeId: string
  location: Location
  name: string
  type: 'config' | 'misc' | 'energy' | 'energyHistory'
  uploaded: boolean
  updated: number
  versionHash: string
  energyConfig?: EnergyConfig
  lightingDevices?: LightingDevice[]
  groups?: {
    name: string
    smartHardwareIDs: string[]
  }[]
}
export interface homeActiveEnergyConfig {
  payload: {
    components?: { deviceID: string; name: string }[]
    connections?: {
      sourceDeviceID: string
      sourceConnector: { connectorName: string }
      sinkDeviceID: string
      sinkConnector: { connectorName: string }
    }[]
    active: boolean
    created: number
    homeId: string
    location: Location
    name: string
    type: 'config' | 'misc' | 'energy' | 'energy_data'
    uploaded: boolean
    updated: number
    versionHash: string
    energyConfig?: EnergyConfig
    lightingDevices?: LightingDevice[]
    groups?: {
      name: string
      smartHardwareIDs: string[]
    }[]
  }
}

export interface EnergyConfig {
  circuits: Circuit[] | null
  panelConfig: PanelConfig | null
  controllers: Controller[]
}

export interface PanelConfig {
  breakerPanels: Panel[]
  breakerPanelModules: Module[]
}

export interface Module {
  breakerName: string
  breakerPanelId: string
  id: string
  slots: number[]
  type: string
  channels?: {
    circuitInId: string
    uid: string
  }[]
}

export interface Controller {
  breakerPanels?: string[]
  microgridConfig?: any
  name: string
}

export interface LightingDevice {
  address: string
  smartHardware: SmartHardware[]
  name: string
  uid: string
  type: string
  loads?: Load[]
}

export interface Load {
  loadID: string
  name: string
  offset: 0
  roomID: string
  circuitName?: string
  status?: number
}

export interface HW {
  ChannelOverride?: State
  CompanionGeneration?: State
  Connected?: State
  DeviceLabel?: State
  DeviceModelDescription?: State
  DeviceModelID?: State
  DimmerCurve?: State
  DimmerMax?: State
  DimmerMin?: State
  DimmerMode?: State
  LoadName?: State
  PanelID?: State
  PartNumber?: State
  SlotNumber?: State
  SlotType?: State
  StartAddress?: State
  State?: State
  UID?: State
  Version?: State
  VersionAvailable?: State
}

export interface Message {
  eventDetails: any
  eventName: string
  eventUnixTime: number
  id: string
  image: string
}

export interface State {
  value: any
}

export interface SmartHardware {
  energyOnly: boolean
  hwUID: string
  isPDU: boolean
  olaConfig: {
    PanelID: string
    SlotNumber: number
    DevicesModelDescription: string
    DeviceModelID: number
  }
  smartHardwareID: string
  status?: number
  circuitName?: string
  homeId?: string
}

export interface Panel {
  id: string
  mac: string[]
  mainBreakerSize: number
  panelHierarchy: string
  panelName: string
  panelType: string
  phases: number
  roomName: string
  slidesNumber: string
  slotsNumber: number
}

export interface Circuit {
  classification: string
  companion: string
  controller: string
  controllerType: string
  groupImage: string
  groupName: string
  id: string
  image: string
  name: string
  productionType: string
  roomID: string
  power: any
  state: any
  status: any
  circuitName?: string
  load?: string
}

export interface HomeSoftwareType {
  created: number
  id: string
  location: HomeSoftwareLocation
  md5: string
  partNumber: string
  uploaded: boolean
  version: HomeSoftwareVersion
  visible: boolean
}

interface HomeSoftwareLocation {
  url: string
  expires: number
}

interface HomeSoftwareVersion {
  build: number
  maintenance: number
  major: number
  minor: number
  name: string
  number: number
}

export enum CloudSoftwareHistoryEnum {
  new = 'NEW',
  error = 'ERROR',
  install = 'INSTALL',
  success = 'SUCCESS',
  reboot = 'REBOOT',
  download = 'DOWNLOAD',
  ready = 'READY',
}

export enum SoftwareHistoryRequestedByEnum {
  user = 'User',
  home = 'Home',
}

export interface HomeCloudSoftwareHistoryType {
  clearConfig: boolean
  created: number
  downloadUrl: string
  homeId: string
  md5Sum: string
  message: string
  partNumber: string
  progress: number
  requestedBy: SoftwareHistoryRequestedByEnum
  state: CloudSoftwareHistoryEnum
  uid: string
  updateId: string
  updated: number
  versionNumber?: number
}

export interface HomeSoftwareHistoryVersion {
  number: number | string
  name: string
  major: number
  minor: number
  maintenance: number
  build: number
}

export interface HomeSoftwareHistoryType {
  id: number
  hostId: string
  startTime?: number
  endTime?: number
  created: number
  version: HomeSoftwareHistoryVersion
}

export interface SubscriptionInfo {
  authority: 'none' | 'billing'
  autoRenew: number | null
  category: 'ESSENTIALS' | 'NETWORK' | null
  beginsAt: number
  created: number | null
  expiresAt: number
  hostTier: string
  count: number
}

export interface SubscriptionInfoArray {
  subscriptionInfo: SubscriptionInfo[]
}

export interface HostCapability {
  type: 'cloudLicenses' | 'enhancedCredentials' | 'remoteDealerInterface'
  version: number
  enabled: 0 | 1
}

export interface HostInfo {
  OSName: string | null
  OSVersion: null
  hostHardwareModel: string | null
  hostMachineType: number
  hostProfileModel: string | null
  hostCapabilities: any[]
}

export interface ConfigHostInfo {
  OSVersion: string
  partNumber: string
  modelNumber: string
  OSName: string
  hostProfileModel: string
  hostHardwareModel: string
}

export interface HostConfig {
  hostInfo?: ConfigHostInfo
  hostCapabilities: HostCapability[]
  hostMachineType: 0 | 1
  updated: number
  homeId: string
  featureLevel: number
}

export interface SubscriptionCredit {
  after: number
  before: number
  products: [SubscriptionCreditProduct]
}

export interface SubscriptionCreditProduct {
  productName: 'Savant Essentials' | 'Smart Network'
  amount: number
}
